
function isYYB() {
  return /\/qqdownloader\/(\d+)(?:\/(appdetail|external))?/.test(window.navigator.userAgent);
}

function yybHandler(url) {
  if (!window || !window.navigator) return false;

  // 以tmast开头的地址，是应用宝的伪协议,需要内部处理
  if (url.startsWith('tmast:')) {
    jumpTmastUrl(url);
    return true;
  }

  // 不在应用宝内，返回false，外部继续向下执行
  if (!isYYB()) return false;

  // 在应用宝内，调用jsb接口进行跳转
  openNewWindow(url);
  return true;
}

/** 在应用宝内打开新页面 */
function openNewWindow(url) {
  if (window.JsBridge) {
    window.JsBridge.call('openNewWindow', { url });
  } else {
    console.error('请先加载应用宝的jsbridge');
  }
}

/** 跳转到应用宝 tmast 伪协议地址 */
function jumpTmastUrl(url) {
  // 在微信内通过 jsbridge 接口跳转到应用宝
  if (window.magicApp?.env?.isWechat) {
    if (window.JsBridge) {
      window.JsBridge.callWithScheme(url);
    } else {
      console.error('请先加载应用宝的jsbridge');
    }

    return;
  }

  // 在应用宝内，和其他场景，直接跳转
  location.href = url;
}


export default yybHandler;
